import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Modal,
  Header,
  Body,
  Footer,
  Close
} from "MODULES/shared/components/Modal";
import * as actions from "MODULES/users/actions";

export class ActivateUser extends Component {
  state = {
    modalOpen: false
  };

  openModal = () => this.setState({ modalOpen: true });

  closeModal = () => this.setState({ modalOpen: false });

  activateUser = () => {
    this.props.updateUser({ active: true });
    this.closeModal();
  };

  render() {
    const { modalOpen } = this.state;

    return (
      <div>
        <button
          className="btn btn-success pull-right"
          style={{ marginLeft: "20px" }}
          onClick={this.openModal}
        >
          <i className="fa fa-fw fa-ban" /> Activate User
        </button>
        <Modal open={modalOpen} close={this.closeModal} dialogClass="modal-sm">
          <Header>
            <Close close={this.closeModal} />
            <h4 className="modal-title">Are You Sure?</h4>
          </Header>
          <Body>
            <div className="alert alert-warning margin-bottom-none">
              <div className="media">
                <div className="media-left">
                  <i className="fa fa-lg fa-warning text-warning" />
                </div>
                <div className="media-body">
                  <strong>Heads up!</strong> Are you sure you want to activate
                  this user?
                </div>
              </div>
            </div>
          </Body>
          <Footer>
            <button
              type="button"
              className="btn btn-default"
              onClick={this.closeModal}
            >
              Cancel
            </button>{" "}
            <button
              type="submit"
              className="btn btn-success"
              onClick={this.activateUser}
            >
              <i className="fa fa-fw fa-ban" /> Yes, Activate User
            </button>
          </Footer>
        </Modal>
      </div>
    );
  }
}

ActivateUser.propTypes = {
  updateUser: PropTypes.func.isRequired
};

export default connect(undefined, { updateUser: actions.update })(ActivateUser);



// WEBPACK FOOTER //
// ./app/modules/users/components/ActivateUser/ActivateUser.jsx